import { useQuery } from 'react-query';
import { DisbursementService } from '@wealthlane/api-services/wealthlane-award-settlement-service';

const useGetDisbursementDashboard = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo?: any
) => {
  const { disbursementStatusIds, disbursementContainerStatusIds, companyIds } = tableInfo;
  const disbursementDashboard = useQuery(['getDisbursementDashboard', tableInfo], async () => {
    return await handleRequest(
      DisbursementService.getApiAwardSettlementApiAppDisbursementDisbursementDashboard(
        [disbursementStatusIds],
        [disbursementContainerStatusIds],
        [companyIds],
        null
      )
    );
  });
  return disbursementDashboard;
};

export default useGetDisbursementDashboard;
